import React from 'react';
import deletePng from '../../assets/images/delete.png';
import Modal from "react-bootstrap/Modal";

function ConfirmModal({ confirmShow, HandleConfirmCancel, HandleConfirmOk }) {
    const isCopy = ["copymark", "copyquote"].includes(confirmShow?.status);
    const isQuotationCopy = confirmShow?.status === "copyquote";

    return (
        <Modal show={confirmShow?.show} centered size='sm' className={isCopy ? 'confirmModal copyVariant' : 'confirmModal deleteModal'}>
            <Modal.Body>
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        {isCopy ? (
                            <div className="confirm-icon copy-icon">
                                <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 8V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-3" stroke="#0d3d78" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                    <rect x="5" y="8" width="11" height="13" rx="1.5" stroke="#0d3d78" strokeWidth="1.8" strokeLinejoin="round" />
                                </svg>
                            </div>
                        ) : (
                            <div className="delete-image">
                                <img src={deletePng} alt="deletePng" />
                            </div>
                        )}
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="confirm-msg mt-3">
                            <h5>{isCopy ? (isQuotationCopy ? "Copy Quotation?" : "Copy Mark?") : "Are you sure?"}</h5>
                            {isCopy ? (
                                <p className="mb-0">Are you sure you want to copy this {isQuotationCopy ? "Quotation" : "Mark"}?</p>
                            ) : (
                                <h6>{confirmShow?.title}</h6>
                            )}
                            {confirmShow?.textCode && (
                                <p className={isCopy ? 'mt-2 confirm-text-pill' : 'mt-2'}>
                                    {confirmShow?.textCode}: <span>{confirmShow?.text}</span>
                                </p>
                            )}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="confirm-btns mt-0">
                            <button type="button" className="btn cancel-btn" onClick={HandleConfirmCancel}>Cancel</button>
                            <button
                                type="button"
                                className={isCopy ? "btn copy-confirm-btn" : "btn delete-confirm-btn"}
                                onClick={() => { HandleConfirmOk(confirmShow?.item) }}
                                disabled={confirmShow?.loading}
                            >
                                {isCopy ? "Copy" : "Ok"}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ConfirmModal;
